import { AccountApi } from '@/api/account.api';
import { eventsApi, EVENTS } from '@/api/events.api';
import { NaluriRefreshTokenError } from '@/errors';
import { TokenStore } from './tokenStore';

let intervalId: NodeJS.Timeout | string | number;

const TWENTY_MINUTES = 20 * 60 * 1000;

export const startRefreshTokenOnInterval = async (
  accountApi: AccountApi,
  tokenStore: TokenStore,
  onRefreshTokenError?: () => Promise<void>
) => {
  const refreshToken = tokenStore.getItem('refreshToken');
  if (!refreshToken) {
    if (onRefreshTokenError) {
      await onRefreshTokenError();
    } else {
      throw new NaluriRefreshTokenError();
    }

    return;
  }

  if (intervalId) clearInterval(intervalId);

  const refreshAccessToken = async () => {
    try {
      const { accessToken } = await accountApi.refresh(refreshToken);
      tokenStore.setItem('accessToken', accessToken);

      startRefreshTokenOnInterval(accountApi, tokenStore, onRefreshTokenError);
    } catch (err) {
      if (eventsApi) {
        eventsApi.track(EVENTS.REFRESH_ERROR, {
          error: err,
        });
      }
      clearInterval(intervalId);
      if (onRefreshTokenError) {
        await onRefreshTokenError();
      } else {
        throw new NaluriRefreshTokenError();
      }
    }
  };

  intervalId = setInterval(refreshAccessToken, TWENTY_MINUTES);
};

export const stopRefreshTokenOnInterval = () => {
  if (intervalId) clearInterval(intervalId);
};
